var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-panel",
    {
      attrs: { visible: _vm.visible, "can-show-header": false },
      on: { closed: _vm.handleClosePanel },
    },
    [
      _c("div", { staticClass: "lens-details-panel__container" }, [
        _c("header", { staticClass: "rb-pdp-mobile-panels__header" }, [
          _c(
            "div",
            {
              staticClass: "lens-details-panel-content__title",
              attrs: { "aria-label": "Lens Details" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.translation("common.oneconf_lensDetails_title")) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "common__icon common__icon--close-side-panel",
              on: { click: _vm.handleClosePanel },
            },
            [_vm._v("\n        close\n      ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "lens-details-panel-content__image" }, [
          _c("img", { attrs: { src: _vm.getBackgroundImage } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pill__container",
              on: {
                mousedown: _vm.showMaskImage,
                mouseup: _vm.hideMaskImage,
                touchstart: function ($event) {
                  $event.preventDefault()
                  return _vm.showMaskImage($event)
                },
                touchend: function ($event) {
                  $event.preventDefault()
                  return _vm.hideMaskImage($event)
                },
              },
            },
            [
              _c("rb-pill", { attrs: { size: "medium", color: "black" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.translation("common.oneconf_lensDetails_tap_hold")
                    )
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("article", { staticClass: "lens-details-panel-content__infos" }, [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.lensDescription) } }),
          _vm._v(" "),
          _c("img", {
            staticClass: "infos-miniature",
            attrs: { src: _vm.getMiniatureImage },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }